import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";

const Accordion: React.FC<AccordionProps> = MuiAccordion;

export default Accordion;
export type { AccordionProps };